import React from 'react';
import themeColors from 'styles/themes/wikifactory/styles/colors';
import { Box } from '@chakra-ui/react';
import type { ThemeColorKey } from 'styles/themes/wikifactory/styles/colors';

export function makeEnumCell(stateEnum: {
  [key: string]: { title: string; color: string };
}) {
  return function StatusCell(key: string) {
    const { color } = stateEnum[key];
    let backgroundColor: string = color;
    if (themeColors[color as ThemeColorKey]) {
      backgroundColor = themeColors[color as ThemeColorKey];
    }
    return (
      <>
        <Box
          width='1rem'
          height='1rem'
          backgroundColor={backgroundColor}
          borderRadius='100%'
          display='inline-block'
          verticalAlign='sub'
          mr={2}
        />
        {stateEnum[key].title}
      </>
    );
  };
}
